import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import PillarArticle from './components/PillarArticle';
import TrustSection from './components/TrustSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const siteUrl = typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env.VITE_SITE_URL || 'https://superbuyspread.boats' : 'https://superbuyspread.boats';

function getOrganizationJsonLd() {
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Superbuy Spreadsheet',
    url: siteUrl,
    description: 'The most complete curated shopping spreadsheet resource with 50,000+ products across 100+ categories.',
    sameAs: [],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer support',
      url: 'https://kaspreadsheet.com',
    },
  });
}

function getWebSiteJsonLd() {
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Superbuy Spreadsheet',
    url: siteUrl,
    potentialAction: {
      '@type': 'SearchAction',
      target: siteUrl + '/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  });
}

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: getOrganizationJsonLd() }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: getWebSiteJsonLd() }}
      />
      <Navbar />
      <Hero />
      <CategoryGrid />
      <PillarArticle />
      <TrustSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </main>
  );
}